import { PropType } from 'vue-demi';
import { TranslateResult } from 'vue-i18n';
import { QueryParam, QuerySchema } from './types';

export const PATH_DELIMITER = '.';
export enum QUERY_PARAM_TYPE {
  STRING = 'STRING',
  DATE_RANGE = 'DATE_RANGE',
  OBJECT = 'OBJECT',
}

export const QUERY_PROP = {
  type: Array as PropType<QueryParam[]>,
  default: () => [],
};

export const PARAM_PROP = {
  type: Object as PropType<QueryParam>,
  default: () => ({}),
  required: true,
};

export const SCHEMA_PROP = {
  type: Object as PropType<QuerySchema>,
  default: () => ({}),
};

export const TRANSLATED_STRING_PROP = {
  type: String as PropType<TranslateResult>,
  default: '',
};

export const STRING_BOOLEAN_MAP_PROP = {
  type: Object as PropType<Record<string, boolean>>,
  default: () => ({}),
};
